import React, {Fragment} from "react";
import {Grid} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

import msgs from "./messages";

import useStyles from "./styles";

const FilesList = ({files}) => {
    const classes = useStyles();
    return (
        <>
            <Typography className={classes.standOutText}>{msgs.title.defaultMessage}</Typography>
            <Box className={classes.formBox}>
                <Grid item container>
                    {!files.length && <span>Not Provided</span>}
                    { files && files.map(({name, uploadDate, lastModifiedDate}, index) => {
                        const date = uploadDate ? uploadDate : lastModifiedDate
                        return <Fragment key={index}>
                            <Grid item xs={12} md={4} className={classes.uploadFileName}>
                                {name}
                            </Grid>
                            <Grid item xs={12} md={8} className={classes.dateFileName}>
                                {window.moment(date.toString()).format('dddd, MMMM Do YYYY, h:mm A')}
                            </Grid>
                        </Fragment>;
                    })}
                </Grid>
            </Box>
        </>
    )
}

export default FilesList;